import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { PerfilUsuarioService } from '../services/perfil-usuario.service'
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
	selector: 'app-perfil-usuario-edit',
	templateUrl: './perfil-usuario-edit.component.html',
	styleUrls: ['./perfil-usuario-edit.component.css'],
	animations: [loadingFade]
})
export class PerfilUsuarioEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public usuario_perfil_id = null;
	public cd_usuario_perfil_samu = "";
	public usuario_perfil_status;
	public usuario_exibir_regiao;

	public formPerfil: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private perfilSvc: PerfilUsuarioService,
				private router: Router) { }

	ngOnInit() {
	
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {
				this.usuario_perfil_id = params.id;
				// pega dados a partir do id
				this.perfilSvc.getPerfilEdit(params.id).then((data: any) => {

					this.preencheForm({
						usuario_perfil_id: data.usuario_perfil_id,
						usuario_perfil_nome: data.usuario_perfil_nome,
						cd_usuario_perfil_samu: data.cd_usuario_perfil_samu,
						usuario_perfil_status: data.usuario_perfil_status == 'A' ? true : false ,
						usuario_exibir_regiao: data.usuario_exibir_regiao == 'A' ? true : false ,
					});

					this.loading = false;

				});
			}
			else {
				this.loading = false;
				this.usuario_perfil_status = "A";
			}
		});



	}

	criaForm() {
		this.formPerfil = this.fb.group({
			usuario_perfil_id: null,
			usuario_perfil_nome: ['', Validators.required],
			cd_usuario_perfil_samu: null,
			usuario_perfil_status: null,
			usuario_exibir_regiao: null
		});
	}

	preencheForm(dados) {
		this.formPerfil.setValue(dados);
	}

	enviaPerfil() {
		if (this.formPerfil.valid) {

			this.submitting = true;
			let toSend = this.formPerfil.value;

			toSend.usuario_exibir_regiao = toSend.usuario_exibir_regiao ? 'A' : 'I';

			if (this.usuario_perfil_id === null) { // criar

				toSend.usuario_perfil_status = "A";

				this.perfilSvc.criaPerfil(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Perfil cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/perfil-usuario']);
						}
					  });
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
					  type: 'error',
					  title: 'Ops! Algo de errado aconteceu!',
					  text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar

				toSend.usuario_perfil_status = toSend.usuario_perfil_status ? 'A' : 'I';	
				this.perfilSvc.editaPerfil(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Perfil alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/perfil-usuario']);
						}
					  });
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
					  type: 'error',
					  title: 'Ops! Algo de errado aconteceu!',
					  text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formPerfil.controls){
				let campo = this.formPerfil.get(field);
				campo.markAsTouched();
			}
     		this.submitting = false;
			Swal.fire({
				type:'error',
				title:'Atenção!',
				text:'Verifique os campos obrigatórios e tente novamente.'

			});
		}
	}

	invalid(nome) {
		let input = this.formPerfil.get(nome);
		return input.touched && input.invalid;
	}


}
